import axios from 'axios';

import store, { history } from 'store';
import { logoutAction } from 'store/auth/action';

const axiosInstance = axios.create();

var tokenStr = null;

export const setToken = token => {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  tokenStr = token;
};

export const removeToken = () => {
  delete axiosInstance.defaults.headers.common['Authorization'];
};

axiosInstance.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(err) {
    if (err.response && err.response.status === 401) {
      history.replace('/');
      store.dispatch(logoutAction());
      return Promise.reject(err);
    }

    const unauthorizedMessage = `You don't have permission to perform this action. Please contact your administrator for this.`;
    if (err.response.status === 403) {
      return Promise.reject(new Error(unauthorizedMessage));
    }

    if (err.response && err.response.data && err.response.data.messages) {
      return Promise.reject(new Error(err.response.data.messages));
    }
    return Promise.reject(err);
  },
);

export default axiosInstance;

export const baseUrl = process.env.REACT_APP_BASE_URL;
export const utilityBaseUrl = process.env.REACT_APP_UTILITY_BASE_URL;
export const eformBaseUrl = process.env.REACT_APP_EFORM_BASE_URL;
export const eformTemplateBaseUrl =
  process.env.REACT_APP_EFORM_TEMPLATE_BASE_URL;
export const pobClientId = process.env.REACT_APP_CLIENT_ID;
export const mobBaseUrl = process.env.REACT_APP_BASE_MOB_URL;
export const pobApiKey = process.env.REACT_APP_API_KEY;

export function generateUtilityUrl(filename) {
  return `${utilityBaseUrl}${filename}?Authorization=${tokenStr}`;
}

export function getToken() {
  return tokenStr;
}
